module.exports = __webpack_public_path__ + "img/guiqi.8641080c.png";